/* eslint-disable import/no-unresolved */
import API_URLS from "src/config/API_URLS";
import DEVICE_INFO from "src/helpers/Payment";
import axiosInstance from "src/utils/Axios/axiosInstance";
import StorageService from "src/utils/Storage/storageService";

const initiatePayment = async (leadId: string) => {
  try {
    const response = await axiosInstance.post(
      `${API_URLS.initiatePayment}/${leadId}`,
      {
        deviceInfo: DEVICE_INFO
      },
      {
        headers: {
          token: StorageService.getFromLocalStorage("paymentToken")
        }
      }
    );
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const paymentStatus = async (orderId: string) => {
  try {
    const response = await axiosInstance.get(API_URLS.paymentStatus, {
      params: {
        orderId
      },
      headers: {
        token: StorageService.getFromLocalStorage("paymentToken")
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export { initiatePayment, paymentStatus };
